import { render } from "./BaseInputErrors.vue?vue&type=template&id=12486376"
import script from "./BaseInputErrors.vue?vue&type=script&lang=js"
export * from "./BaseInputErrors.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__